export default __webpack_public_path__ + "static/media/street_wear_card.3a49ee9f.svg";